import React, { useState } from "react";
import * as XLSX from "xlsx";
import { Box, Paper, Typography, CircularProgress, TextField, Tooltip, Button, Grid, IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";
import { grey } from "@mui/material/colors";

function ProductSelectionSection() {
	const [discountBarcodes, setDiscountBarcodes] = useState("");
	const [nodBarcodes, setNodBarcodes] = useState("");
	const [loadingType, setLoadingType] = useState("");
	const [dragOver, setDragOver] = useState("");

	const handleFileUpload = (file, type) => {
		if (!file) return;

		setLoadingType(type);

		const reader = new FileReader();
		reader.onload = (event) => {
			setTimeout(() => {
				try {
					const data = new Uint8Array(event.target.result);
					const workbook = XLSX.read(data, { type: "array" });
					const worksheet = workbook.Sheets[workbook.SheetNames[0]];
					const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

					const barcodes = jsonData
						.slice(1)
						.map((row) => row[0])
						.filter((barcode) => barcode)
						.slice(0, 1000); // limit for performance

					const barcodeText = barcodes.join("\n");

					if (type === "discount") setDiscountBarcodes(barcodeText);
					else if (type === "nod") setNodBarcodes(barcodeText);
				} catch (error) {
					console.error("File processing error:", error);
				} finally {
					setLoadingType("");
				}
			}, 100);
		};

		reader.readAsArrayBuffer(file);
	};

	const handleDrop = (e, type) => {
		e.preventDefault();
		setDragOver("");
		const file = e.dataTransfer.files[0];
		handleFileUpload(file, type);
	};

	const renderUploadSection = (type, value, setValue, label) => (
		<Paper
			elevation={3}
			sx={{
				p: 2,
				minWidth: 450,
				position: "relative",
				height: 300,
				border: dragOver === type ? "2px dashed #2196f3" : "1px solid #ddd",
				bgcolor: dragOver === type ? "#f0faff" : "white",
				transition: "0.2s",
				overflow: "hidden",
			}}
			onDragOver={(e) => {
				e.preventDefault();
				setDragOver(type);
			}}
			onDragLeave={() => setDragOver("")}
			onDrop={(e) => handleDrop(e, type)}>
			<Typography variant="h6" gutterBottom>
				{label}{" "}
				<Tooltip title="Drag and drop only csv files" placement="right-end">
					<IconButton size="small">
						<InfoIcon fontSize="small" />
					</IconButton>
				</Tooltip>
			</Typography>

			{/* "+" Watermark if empty */}
			{!value && loadingType !== type && (
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						color: "#ccc",
						cursor: "pointer",
						userSelect: "none",
						zIndex: 0,
					}}
					onClick={() => document.getElementById(`${type}-upload`).click()}>
					<FileUploadRoundedIcon fontSize="large" sx={{ transform: "scale(1.8)" }} />
				</Box>
			)}

			{/* Hidden file input */}
			<input
				type="file"
				accept=".csv,.xlsx,.xls"
				id={`${type}-upload`}
				hidden
				onChange={(e) => handleFileUpload(e.target.files[0], type)}
			/>

			{/* Textarea */}
			<Box sx={{ mt: 2, position: "relative", zIndex: 1 }}>
				{loadingType === type ? (
					<CircularProgress size={24} />
				) : (
					<Box border={`1px solid ${grey[500]}`}>
						<TextField
							fullWidth
							multiline
							minRows={8}
							variant="outlined"
							value={value}
							sx={{
								overflowY: "scroll",
								height: 245,
								border: "0px",
								"& .MuiOutlinedInput-root": {
									"& fieldset": {
										border: "none",
									},
								},
							}}
							onChange={(e) => setValue(e.target.value)}
							placeholder="Enter barcodes one per line..."
						/>
					</Box>
				)}
			</Box>
		</Paper>
	);

	return (
		<Box display="flex" gap={2} flexWrap="wrap">
			{renderUploadSection("discount", discountBarcodes, setDiscountBarcodes, "Barcode on Discount")}
			{renderUploadSection("nod", nodBarcodes, setNodBarcodes, "NOD Barcodes")}
		</Box>
	);
}

export default ProductSelectionSection;
